const $ = jQuery.noConflict();

'use strict';
const Features = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	$domBoxesWithLinks: $('.js-feature__content-box--popup'),
	$domFeature: $('.js-feature'),

	$domNavFeature: $('.js-feature__nav'),
	classNavScroll: 'nav-scroll',

	$domNavItem: $('.js-feature__nav-item'),

	/** @description Initialize */
	init: function() {
		this.showBoxes();
		this.fixedNav();
		this.navItemClick();
	},

	navItemClick: () => {
		const navLink = Features.$domNavFeature.find('a');
		navLink.on('click', function() {
			navLink.removeClass('nav-item-active');
			$(this).addClass('nav-item-active');
		});
	},

	showBoxes: ()=> {
		if(Features.$domFeature.length > 0) {
			$('.js-feature__content-show-link').on('click', function() {
				$(this).parents('.feature__contnent-boxes-block-wrap').find('.feature__content-box-wrapper--hidden').stop().slideDown();
				setTimeout(() => {
					$(this).addClass('remove-btn');
				}, 1000);
			});
		}
	},

	fixedNav: ()=> {
		if(Features.$domNavFeature.length > 0) {
			let fixmeTop = 0;

			if($(window).width() > 767) {
				fixmeTop =Features.$domNavFeature.offset().top + 80;
			}else {
				fixmeTop =Features.$domNavFeature.offset().top - 80;
			}

			$(window).scroll(function() {

				const currentScroll = $(window).scrollTop();

				if(currentScroll >= fixmeTop) {
					Features.$domNavFeature.addClass(Features.classNavScroll);
					$('.js-feature__content-bottom').addClass('added-spacing');
				}else {
					Features.$domNavFeature.removeClass(Features.classNavScroll);
					$('.js-feature__content-bottom').removeClass('added-spacing');
				}
			});
		}
	},
};

export default Features;